import React, { useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { CloseX } from "../Icons";
import styles from "./Modal.module.css";

type ModalProps = {
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
};

const Modal = ({ children, onClose, title = "" }: ModalProps) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    },
    [onClose],
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation();

  if (typeof document === "undefined") return null;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div aria-modal='true' className={styles.dialog} onClick={stopPropagation} role='dialog'>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <button aria-label='Close modal' className={styles.closeButton} onClick={onClose} type='button'>
            <CloseX />
          </button>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
